import { trpc } from '@/shared/api/trpc';

export const useCreateTaskCollection = () => {
  const utils = trpc.useUtils();
  return trpc.taskCollections.create.useMutation({
    onSettled: () => {
      utils.taskCollections.list.invalidate();
      // New collection becomes immediately eligible for any itinerary;
      // the per-itinerary availability query needs a refresh.
      utils.taskCollections.availableForItinerary.invalidate();
    },
  });
};
